module.exports = __webpack_public_path__ + "static/media/orange-p.095c00de.svg";